import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { useUser } from "../../context/UserContext";
import { useNavigate } from "@tanstack/react-router";
import { useLoginMutation } from "../../hooks/useLoginMutation";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

const Login = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const loginMutation = useLoginMutation();
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = useCallback(async (event) => {
    event.preventDefault();
    const { email, password } = event.target.elements;
    
    try {
      const res = await loginMutation.mutateAsync({
        email: email.value,
        password: password.value,
        navigate,
      });
      
      if (res) {
        setUser(res);
      }
    } catch (error) {
      // Use the user-friendly message from our error handler
      const errorMessage = error.userMessage || error.message || "Η σύνδεση απέτυχε. Παρακαλώ δοκιμάστε ξανά.";
      toast.error(errorMessage);
    }
  }, [loginMutation, navigate, setUser]);

  return (
    <div className="mt-20 flex items-center justify-center w-full">
      <div className="bg-white sm:shadow-md sm:rounded-lg px-8 py-6 w-full sm:w-96 sm:ring-1 sm:ring-gray-100">
        <h1 className="text-2xl font-bold text-center mb-4">Καλώς ήρθες!</h1>
        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label
              form="email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              placeholder="your@email.com"
              required
            />
          </div>
          <div className="mb-4">
            <label
              form="password"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Κωδικός
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="shadow-sm rounded-md w-full px-3 py-2 pr-10 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="Εισάγεται των κωδικό σας"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <EyeSlashIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                ) : (
                  <EyeIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                )}
              </button>
            </div>
          </div>
          <button
            type="submit"
            disabled={loginMutation.isPending}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-800 hover:bg-gray-600 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loginMutation.isPending ? (
              <div className="flex items-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Σύνδεση...
              </div>
            ) : (
              "Σύνδεση"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};
export default Login;
